<template>
  <NavBarItem
    v-if="
      $branding.isPriceOffer && availableLocales.length > 1 && !isUserLoggedIn
    "
    id="locale-selector"
    :icon="currentFlagIcon"
    icon-pack="flags"
    :text="currentLocaleName"
    :items="localeMenuItems"
    :is-last="true"
    class="locale-selector-item"
    :type="type"
  />
</template>

<script>
import { computed } from "vue";
import { useContext } from "@nuxtjs/composition-api";
import NavBarItem from "~/components/_refactored/header/NavBarItem.vue";
import { getCountryCode, getLocaleName } from "~/locales/config.js";
import { useUserStore } from "~/stores/user";

export default {
  name: "LocaleSelector",
  components: {
    NavBarItem,
  },
  props: {
    type: {
      type: String,
      default: "default",
    },
  },
  setup() {
    const { i18n, switchLocalePath, $branding } = useContext();
    const userStore = useUserStore();

    // Check if user is logged in
    const isUserLoggedIn = computed(() => !!userStore.me);

    // Get available locales from i18n
    const availableLocales = computed(() => {
      // If brand has supportedLocales configuration, use that
      if ($branding.supportedLocales && $branding.supportedLocales.length > 0) {
        return i18n.locales.filter((locale) =>
          $branding.supportedLocales.includes(locale.code)
        );
      }
      // Otherwise, use all configured locales
      return i18n.locales;
    });

    // Current locale flag icon
    const currentFlagIcon = computed(() => {
      return getCountryCode(i18n.locale);
    });

    // Current locale name
    const currentLocaleName = computed(() => {
      return getLocaleName(i18n.locale);
    });

    // Create menu items for other locales
    const localeMenuItems = computed(() => {
      return availableLocales.value
        .filter((locale) => locale.code !== i18n.locale)
        .map((locale) => {
          return {
            id: `locale-${locale.code}`,
            icon: getCountryCode(locale.code),
            iconPack: "flags",
            text: getLocaleName(locale.code),
            click: () => {
              window.location.href = switchLocalePath(locale.code);
            },
          };
        });
    });

    return {
      isUserLoggedIn,
      availableLocales,
      currentFlagIcon,
      currentLocaleName,
      localeMenuItems,
    };
  },
};
</script>
